export enum EquipAppSupportPermissions {
  PROXY = 'Proxy',
  GENERAL = 'General',
}

export const EquipAppSupportPermissionsList = [
  EquipAppSupportPermissions.PROXY,
  EquipAppSupportPermissions.GENERAL,
];
